import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';

type NavigationId = number;

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryStack {
  private history: NavigationId[] = [];

  constructor(private router: Router) {
    const routerEventHandler = this.handleRouterEvent.bind(this);
    this.router.events.subscribe(routerEventHandler);
  }

  public isEmpty(): boolean {
    return this.history.length === 0;
  }

  private handleNavigationStart(event: NavigationStart): void {
    const restoredState = event.restoredState;
    const previousNavigationId = this.history[this.history.length - 1];

    const hasNavigatedBack =
      previousNavigationId !== undefined &&
      restoredState?.navigationId !== undefined &&
      previousNavigationId === restoredState?.navigationId;
    if (hasNavigatedBack) {
      this.history.pop();
    } else {
      this.history.push(event.id);
    }
  }

  private handleRouterEvent(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.handleNavigationStart(event);
    } else if (event instanceof NavigationError) {
      this.history.pop();
    } else if (event instanceof NavigationCancel) {
      this.history.pop();
    }
  }
}
